module.exports = __webpack_public_path__ + "static/media/DKTN.ed938d1f.svg";